import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../../Common/CommonVariables'

export const GetCaseStageList = async() => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + 'CaseStage/GetAllCaseStageList'), 
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const CreateNewCaseStage = async (caseStageDet) => {
    //debugger;
    //console.log(JSON.stringify(caseStageDet))
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `CaseStage/CreateNewCaseStage`, 
        JSON.stringify(caseStageDet), 
        CommonVariables.API_HEADER)
        ).then(response => response);
    return result;
}

export const ActivateDeActivateCaseStage = async(Id, IsActive) => {
    //debugger;
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `CaseStage/ActivateDeActivateCaseStage?caseStageId=${Id}&IsActive=${IsActive}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const UpdateCaseStage = async(caseStageDet) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'CaseStage/UpdateCaseStage', 
        JSON.stringify(caseStageDet),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}